import CombinedLabelValue from './CombinedLabelValue'
import OpenResponseBlock from './OpenResponseBlock'
import LabelValue from './LabelValue'

export default ({
  data = {}
}) => {
  const {
    // Top level data points
    // SF_OF_CODES_ACTIVATED__C: { value: ofCodesActivate } = {},
    SF_OF_CODES_CONSUMED__C: { value: ofCodesConsumed } = {},
    SF_TOTAL_STUDENTS: { value: totalStudents } = {},
    // SURVEY_FACILITATORS_POST_EXCITEMENT: { value: facilitatorsPostExcitement } = {},
    SURVEY_SUMMER2025_TAGS_COMMUNICATION: { value: communication } = {},
    // SURVEY_SUMMER2025_TAGS_CRITICAL_THINKING: { value: criticalThinking } = {},
    // SURVEY_SUMMER2025_TAGS_CREATIVE_PROBLEM_SOLVING: { value: creativeProblemSolving } = {},
    // SURVEY_SUMMER2025_TAGS_GROWTH_MINDSET: { value: growthMindset } = {},
    // SURVEY_SUMMER2025_TAGS_FUN_ENGAGING: { value: funEngaging } = {},
    SURVEY_SUMMER2025_TAGS_FUN_JOY: { value: funJoy } = {},
    SURVEY_SUMMER2025_TAGS_COLLABORATION: { value: collaboration } = {},
    SURVEY_SUMMER2025_TAGS_SOCIAL_AWARENESS: { value: socialAwareness } = {},
    // SURVEY_STUDENT_TESTIMONIALS = [],
    SURVEY_STUDENT_TESTIMONIALS_TWO = [],
  } = data;

  // const hasValueIncludingZero = (value) =>   {
  //   return !(!value && value !== 0);
  // }

  // const ratioPlayingQuest = (hasValueIncludingZero(ofCodesActivate) && hasValueIncludingZero(ofCodesConsumed)) ? `${ofCodesActivate} / ${ofCodesConsumed}` : '-'

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '15px'
    }}>
      <div style={{
        color: '#565656',
        fontSize: '24px',
        fontWeight: 'bold',
        borderBottom: '1px solid #565656'
      }}>
        {'Core Data'}
      </div>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        padding: '5px',
        gap: '15px',
      }}>
        <CombinedLabelValue
          label='students playing QUEST'
          value={totalStudents}
        />
        <CombinedLabelValue
          label='classes playing QUEST'
          value={ofCodesConsumed}
        />
        <CombinedLabelValue
          label='of students who said QUEST is FUN!'
          value={funJoy}
          isPercent={true}
        />
        {/* <CombinedLabelValue
          label='classes playing QUEST'
          value={ratioPlayingQuest}
        /> */}
        {/* <CombinedLabelValue
          label='of facilitators enjoying playing QUEST'
          value={facilitatorsPostExcitement}
          isPercent={true}
        /> */}
      </div>

      <div style={{
        color: '#565656',
        fontSize: '24px',
        fontWeight: 'bold',
        borderBottom: '1px solid #565656'
      }}>
        {'QUEST Builds Human Skills'}
      </div>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        padding: '5px',
        gap: '15px',
      }}>
        <LabelValue
          label='Communication'
          value={communication}
          isPercent={true}
        />
        <LabelValue
          label='Collaboration'
          value={collaboration}
          isPercent={true}
        />
        <LabelValue
          label='Social Awareness'
          value={socialAwareness}
          isPercent={true}
        />
        {/* <CombinedLabelValue
          label='of students say they used CRITICAL THINKING'
          value={criticalThinking}
          isPercent={true}
        />
        <CombinedLabelValue
          label='of students are applying CREATIVITY'
          value={creativeProblemSolving}
          isPercent={true}
        />
        <CombinedLabelValue
          label='of students are building RESILIENCE'
          value={growthMindset}
          isPercent={true}
        /> */}
      </div>

      <div style={{
        color: '#565656',
        fontSize: '24px',
        fontWeight: 'bold',
        borderBottom: '1px solid #565656'
      }}>
        {'Student Testimonials'}
      </div>

      <OpenResponseBlock
        header='Question: “What did you hear the kids say about QUEST today? Share quotes and funny moments!”'
        data={SURVEY_STUDENT_TESTIMONIALS_TWO}
      />

    </div>
  )
}